module.exports = __webpack_public_path__ + "static/nutriplate-ca14e22922776cbfb558f7048f133b33.jpg";